import DocumentSearch from './DocumentSearch';

export default DocumentSearch;
